export function calculateAnnuityPayment(sum, percent, months) {
    if (percent < 0 || percent > 1) {
        throw new Error('Процент(rate) не может быть больше 1 или меньше 0');
    }
    const monthlyRate = percent / 12;
    const coefficient = (monthlyRate * Math.pow(1 + monthlyRate, months)) / (Math.pow(1 + monthlyRate, months) - 1);
    const payment = sum * coefficient;
    return Math.round(payment);
}
